export const ACTION_MODAL = 'ACTION_MODAL';